import {Box, Button, Image, Select, Sidebar, Text, Tip} from "grommet";
import {Analytics, Checkmark, Configure, Cubes, Home, List, MapLocation, Plan, UserWorker} from "grommet-icons";
import {Notification as NotificationApp} from "grommet-icons/icons";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft.js";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight.js";
import React, {useState} from "react";
import SideBarButton from "./SideBarButton.jsx"
import {routes} from "../../routes.js";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
  

function SideBarDesktop(props){

        function openGate(){

            const url = process.env.REACT_APP_BACKEND_HOST+'/api/clubmate/gate-opener';
            const accessToken = sessionStorage.getItem("accessToken");
            fetch(url, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`,
                },
                body: JSON.stringify({"direction": "Ingresso"}),
            })
                .then(response => response.json())
                .then(result => {
                    alert("Cancello aperto")
                })
                .catch(error => {
                    console.error('Si è verificato un errore:', error);
                });

        }

    function closeGate(){
        const url = process.env.REACT_APP_BACKEND_HOST+'/api/clubmate/gate-opener';
        const accessToken = sessionStorage.getItem("accessToken");
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`,
            },
            body: JSON.stringify({"direction": "Uscita"}),
        })
            .then(response => response.json())
            .then(result => {
                alert("Cancello chiuso")
            })
            .catch(error => {
                console.error('Si è verificato un errore:', error);
            });

    }


        const [isHovered, setIsHovered] = useState(false);
        return (
            <Sidebar
                width={!props.smallSideBar ? "300px" : "100px"}
                height={"100vh"}
                responsive={true}
                style={{boxShadow: "1px -1px 9px 0px rgb(0 0 0 / 31%)"}}
                header={
                    <Box align="center" height="100vh">
                        {
                            !props.smallSideBar ?
                                <>
                                    <Box height="20px">
                                        {props?.ruoli && Array.isArray(props?.cantieri) && props?.cantieri.length > 0 ?
                                            (props?.ruoli?.Ruolo === 'Admin_Cantiere' ?
                                                    <Select
                                                        options={props?.cantieri}
                                                        labelKey={(option) => option?.name}
                                                        value={props?.newCantiere}
                                                        onChange={({option}) => props?.handleCantiere(option)}
                                                    />
                                                    :
                                                    (props?.ruoli?.Ruolo === 'Admin_Zona' ?
                                                            <Select
                                                                options={props?.cantieri[0].Zona.map(cantiere => (cantiere))}
                                                                value={props?.newCantiere}
                                                                onChange={({option}) => props?.handleCantiere(option)}
                                                            />
                                                            :
                                                            null
                                                    )
                                            )
                                            :
                                            null
                                        }
                                    </Box>
                                    <Box direction={"column"} height="small" pad="small">
                                        <Image fit="contain" src="./images/LogoClubMate.png"/>
                                        <Box alignSelf="center" direction="row" gap="medium">
                                            <Tip content="Apri il cancello" dropProps={{ align: { bottom: 'top' } }}>
                                                <Button
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        background: 'linear-gradient(45deg, #f8b20e, #f89b0e)',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        textTransform: 'uppercase',
                                                        borderRadius: "50%",
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                    hoverIndicator={{
                                                        background: 'linear-gradient(45deg, #f89b0e, #f8b20e)',
                                                        elevation: 'medium',
                                                    }}
                                                    onClick={() => openGate()}
                                                >
                                                    <Box pad="small" align="center" justify="center">
                                                        <MeetingRoomIcon style={{ fontSize: 30 }} />
                                                    </Box>
                                                </Button>
                                            </Tip>
                                            <Tip content="Chiudi il cancello" dropProps={{ align: { bottom: 'top' } }}>
                                                <Button
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        background: 'linear-gradient(45deg, #f8b20e, #f89b0e)',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        textTransform: 'uppercase',
                                                        borderRadius: "50%",
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                    hoverIndicator={{
                                                        background: 'linear-gradient(45deg, #f89b0e, #f8b20e)',
                                                        elevation: 'medium',
                                                    }}
                                                    onClick={() => closeGate()}
                                                >
                                                    <Box pad="small" align="center" justify="center">
                                                        <DoorFrontIcon style={{ fontSize: 30 }} />
                                                    </Box>
                                                </Button>
                                            </Tip>
                                        </Box>
                                    </Box>
                                </>
                                :
                                null
                        }
                        <Box ref={props?.scrollSidebar} width={"100%"} align="center" direction="column" gap="7px" style={{overflowX: "hidden"}}>
                            {
                                routes.map((route,index) => {
                                    if(route?.role?.includes(props?.ruoli?.Ruolo)){
                                        return(
                                            <SideBarButton actualPage={props?.actualPage} setPage={props?.setPage} smallSideBar={props?.smallSideBar} page={route?.name} key={index} name={route?.name} pageName={route?.pageName} icon={route?.icon}/>
                                        )
                                    }
                                })
                            }



                            <Button style={{
                                width: !props.smallSideBar ? '200px' : "50px",
                                fontSize: '10px',
                                //background: props.page === "Notifiche" ? '#f8b20e' : '#FFFFFF',
                                color: 'white',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                borderRadius: "20px",
                                transition: 'background-color 0.2s ease',
                                background: isHovered ? 'rgba(248, 178, 14,0.4)' : (props.page === "Notifiche" ? '#f8b20e' : '#FFFFFF'),
                                cursor: 'pointer' // Aggiungi il cursore a puntatore su hover
                            }} 
                            onMouseEnter={() => setIsHovered(true)} 
                            onMouseLeave={() => setIsHovered(false)} 
                            onClick={() => {
                                props?.setPage("Notifiche")
                            }}
                                    badge={{
                                        background: props?.notifications?.length === 0 ? "none" : "status-critical",
                                        value: props?.notifications?.length === 0 ? false : props?.notifications?.length,
                                        max: 9,
                                        size: 'small'
                                    }}
                            >
                                <Box pad="small" direction="row" align="center" gap="medium">
                                    <NotificationApp color={props.page == "Notifiche" ? '#FFFFFF' : 'black'}/>
                                    {
                                        !props.smallSideBar &&
                                        <Text size="xsmall"
                                              color={props.page == "Notifiche" ? '#FFFFFF' : 'black'}>Notifiche</Text>
                                    }

                                </Box>
                            </Button>
                        </Box>
                    </Box>

                }

                footer={
                    <div align="space-between" gap="small">
                        <Button style={{
                            width: "55px",
                            background: 'white',
                            color: '#f8b20e',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            borderRadius: "20px"}}

                                onClick={() => props?.handleforlogout()}
                        >
                            <Box pad="small" direction="row" align="center" gap="medium">
                                <LogoutOutlinedIcon color='primary' fontSize="large"/>
                            </Box>
                        </Button>


                        {!props.smallSideBar ?
                        <Button style={{
                            width: "55px",
                            background: 'white',
                            color: 'rgb(248, 178, 14)',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            borderRadius: "20px"
                        }} onClick={() => {
                            props?.setSmallSideBar(true);
                            sessionStorage.setItem("smallSidebar", true)
                        }}>
                            <Box pad="small" direction="row" align="center" gap="medium">
                                <ArrowCircleLeftIcon fontSize="large"/>
                            </Box>
                        </Button>
                        :

                        <Button style={{
                            width: "55px",
                            background: 'white',
                            color: 'rgb(248, 178, 14)',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            borderRadius: "20px"
                        }} onClick={() => {
                            props?.setSmallSideBar(false);
                            sessionStorage.setItem("smallSidebar", false)
                        }}>
                            <Box pad="small" direction="row" align="center" gap="medium">
                                <ArrowCircleRightIcon fontSize="large"/>
                            </Box>
                        </Button>}
                        </div>
                }
                        
                    
            >
            </Sidebar>
        )
};

export default SideBarDesktop